import { UniversityStudyRoomTemplate } from "@/components/UniversityStudyRoomTemplate";

const OCADUniversity = () => {
  return (
    <UniversityStudyRoomTemplate
      universityName="OCAD University"
      universityShortName="OCAD"
      slug="ocad-university"
      seoTitle="OCAD University Study Rooms | Library Learning Zone Study Guide"
      seoDescription="Complete guide to study spaces at OCAD University. Find the Library Learning Zone, open studios, and creative work areas. Plus free 24/7 online alternative."
      seoKeywords="ocad study rooms, ocad university library, library learning zone, ocad study spaces, art school study, ocad llz"
      canonicalUrl="/study-room/ocad-university/"
      heroDescription="A comprehensive guide to study and creative work spaces at OCAD University, including the Library Learning Zone."
      libraryWebsiteUrl="https://www.ocadu.ca/services/library"
      libraryWebsiteName="OCAD Library"
      studySpaces={[
        {
          name: "Library Learning Zone (LLZ), 113 McCaul St.",
          features: "Provides an alternative work and study space supporting creative practices. The LLZ offers computer work stations, printers, scanners and table space for non-toxic studio work. Collections include reference books, new books, zines and art & design annuals. The space hosts workshops and events.",
          feedback: "LLZ is lively and may host events, which can be distracting during study time."
        },
        {
          name: "Campus Lounges and Open Studios",
          features: "Many art students work in open studios, cafés or building lobbies between classes.",
          feedback: "Study rooms are first-come, first-served, leaving no private spaces to reserve. Students seeking privacy for therapy calls or quiet online classes express frustration at the lack of reservable rooms."
        },
        {
          name: "Building Common Areas",
          features: "Various seating areas throughout OCAD buildings for informal study and creative work.",
          feedback: "Many campus areas are overcrowded and loud according to student feedback."
        }
      ]}
      guideContent={
        <>
          <p className="mb-4">
            Because OCAD is an art and design school, its spaces are designed for collaboration and making. The <strong>Library Learning Zone</strong> functions as both a studio and study space; here you can sketch, scan or print while flipping through zines.
          </p>
          <p className="mb-4">
            However, <strong>privacy is scarce</strong>. If you need a quiet place for an online class or private call, plan ahead: early mornings or less busy corners of the LLZ offer some solitude, but there are no formal booking options.
          </p>
          <p>
            Off-campus cafés or the nearby <strong>Art Gallery of Ontario lobby</strong> can provide an alternative if campus is too loud. Carry headphones and embrace OCAD's creative energy—you'll likely be studying beside someone building a model or painting a canvas.
          </p>
        </>
      }
      summaryTips={[
        "Embrace the creative atmosphere: OCAD spaces are designed for making, not just reading—expect an active environment.",
        "Arrive early for quiet: Early mornings offer the best chance for a peaceful study session in the LLZ.",
        "No booking available: Study rooms are first-come, first-served, so you can't reserve private space.",
        "Try the AGO lobby: The nearby Art Gallery of Ontario offers a quiet alternative when campus is too loud.",
        "Use CSW for privacy: Virtual study rooms offer the quiet, private space that OCAD campus lacks."
      ]}
    />
  );
};

export default OCADUniversity;
